import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { kebabCase } from 'lodash';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import AssetSelectionModal from './asset/assetSelectionModal';
import entityComposition from '../../common/classes/entityComposition';
import TextField from './textField';
import { labelSelector, valueSelector } from '../selectors';
import logValueOnChange from '../commonActions/logValueOnChange';
const AssetPickerField = _ref => {
  let _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {
      title: ''
    } : _ref$value;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  const handleSelect = useCallback(function () {
    onChange(...arguments);
    setIsModalOpen(false);
  }, [onChange]);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const textFieldID = "input-".concat(kebabCase(label)); // matches textField implementation
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    enabled: false,
    format: {
      label
    } // format.label read by labelSelector. Could change to accept props.label
    ,
    value: value.title,
    onChange: () => {},
    onFocus: toggleModal
  }), /*#__PURE__*/React.createElement(AssetSelectionModal, {
    isOpen: isModalOpen,
    onToggle: toggleModal,
    onSelect: handleSelect,
    targetElementID: textFieldID
  }));
};
AssetPickerField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  })
};
export { AssetPickerField as UncomposedAssetPickerField };
export default entityComposition(AssetPickerField, [], {
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange
});